import { motion } from "framer-motion";

const SPECIES = [
  { name: "Snow Leopard", status: "Vulnerable", pop: "≈4,000", img: "https://images.pexels.com/photos/29069019/pexels-photo-29069019.jpeg?auto=compress&cs=tinysrgb&w=1200", region: "Himalaya" },
  { name: "Great Indian Bustard", status: "Critically Endangered", pop: "<150", img: "https://images.unsplash.com/photo-1591824438708-ce405f36ba3d?w=1200&auto=format&fit=crop", region: "India" },
  { name: "Monarch Butterfly", status: "Endangered", pop: "−22% YoY", img: "https://images.unsplash.com/photo-1560717845-968823efbee1?w=1200&auto=format&fit=crop", region: "N. America" },
  { name: "Polar Bear", status: "Vulnerable", pop: "≈26,000", img: "https://images.unsplash.com/photo-1589656966895-2f33e7653819?w=1200&auto=format&fit=crop", region: "Arctic" },
  { name: "Amur Leopard", status: "Critically Endangered", pop: "≈120", img: "https://images.unsplash.com/photo-1552410260-0fd9b577afa6?w=1200&auto=format&fit=crop", region: "Russia" },
  { name: "Vaquita Porpoise", status: "Critically Endangered", pop: "<10", img: "https://images.unsplash.com/photo-1608889476561-6242cfdbf622?w=1200&auto=format&fit=crop", region: "Gulf of California" },
];

export default function BiodiversityGallery() {
  return (
    <section data-testid="biodiversity-section" className="py-24 md:py-40 px-6 md:px-10 max-w-[1600px] mx-auto">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-16">
        <div className="md:col-span-5">
          <div className="font-mono-tech text-[10px] tracking-[0.4em] uppercase text-[color:var(--np-muted)] mb-4">/07 · Biodiversity</div>
          <h2 className="font-serif-display text-5xl md:text-7xl leading-[0.95] tracking-tighter">Every species,<br/>a profile.</h2>
        </div>
        <p className="md:col-span-6 md:col-start-7 self-end text-[color:var(--np-text-2)] text-lg">
          46,300+ species are threatened with extinction. Behind every number is a name, a habitat, and a story. We track the record — and the recoveries.
        </p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 gap-px bg-black/10">
        {SPECIES.map((s, i) => (
          <motion.figure
            key={s.name}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-10%" }}
            transition={{ duration: 0.6, delay: i * 0.05 }}
            className="relative group aspect-[3/4] overflow-hidden bg-[color:var(--np-bg)]"
            data-testid={`species-card-${i}`}
          >
            <img src={s.img} alt={s.name} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/95 via-black/40 to-transparent" />
            <figcaption className="absolute inset-x-0 bottom-0 p-6">
              <div className="font-mono-tech text-[10px] tracking-[0.35em] uppercase text-[color:var(--np-live)]">{s.region}</div>
              <div className="font-serif-display text-3xl md:text-4xl leading-tight mt-2">{s.name}</div>
              <div className="mt-3 flex items-center justify-between font-mono-tech text-[10px] tracking-[0.3em] uppercase">
                <span className="text-[color:var(--np-alert)]">{s.status}</span>
                <span className="text-white/70">{s.pop}</span>
              </div>
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </section>
  );
}
